import ApiModeSelection from 'app/models/api_mode_selection';
import CashFlowReport from 'app/models/cash_flow_report';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import UTCOffsetSelection from 'app/models/utc_offset_dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import RequestReportView from 'app/views/request_report_view'
import SelectorView from 'app/views/selector_view';

import PageHeaderView from 'app/components/page_header';

import tmpl from './template';

export const MIN_DATERANGE_DATE = '2016-11-01';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'cash-flow',

  initialize() {
    this.apiModeSelection = new ApiModeSelection({ mode: 'production' });
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATE });
    this.utcOffsetSelection = new UTCOffsetSelection();
    this.dropdownSelections = [ this.utcOffsetSelection ];

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Cash Flow',
    }));
    this.addSubview('datePickers', '#cash_flow_daterange_pickers', new DatepickerRangeView({
      model: this.dateRange, minDate: MIN_DATERANGE_DATE,
    }));
    this.addSubview('utcOffsetSelector', '#utc_offset_selector', new SelectorView({ model: this.utcOffsetSelection }));
    this.addSubview('requestCashFlowReport', '#request_cash_flow_report', new RequestReportView({
      ReportClass: CashFlowReport, dateRange: this.dateRange,
      apiModeSelection: this.apiModeSelection, dropdownSelections: this.dropdownSelections,
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/cash_flow/index.js